import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { HeroSection } from "./HeroSection";
import { HowItWorks } from "./HowItWorks";
import { Features } from "./Features";
import { Footer } from "./Footer";

export const HomeContainer = () => {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "hsl(30, 50%, 98%)" }}>
      <HeroSection />
      <HowItWorks />
      <Features />

      <Container
        maxWidth="md"
        sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}
      >
        <Typography
          variant="h3"
          sx={{
            fontFamily: '"Mountains of Christmas", cursive',
            color: "hsl(350, 80%, 40%)",
            mb: 2,
            fontSize: { xs: "1.8rem", md: "2.5rem" },
          }}
        >
          Έτοιμος να σκορπίσεις τη χαρά;
        </Typography>
        <Typography
          sx={{ color: "hsl(150, 20%, 35%)", mb: 4, fontSize: "1.1rem" }}
        >
          Δημιούργησε την πρώτη σου Χριστουγεννιάτικη λοταρία και κάνε αυτή τη
          γιορτινή περίοδο αξέχαστη!
        </Typography>
        <Button
          component={Link}
          to="/lotteries/new"
          variant="contained"
          size="large"
          sx={{
            background:
              "linear-gradient(135deg, hsl(350, 80%, 40%) 0%, hsl(350, 85%, 30%) 100%)",
            color: "white",
            fontWeight: 600,
            px: 5,
            py: 1.5,
            borderRadius: 3,
            fontSize: "1.1rem",
            "&:hover": {
              background:
                "linear-gradient(135deg, hsl(350, 75%, 45%) 0%, hsl(350, 80%, 35%) 100%)",
              transform: "translateY(-2px)",
            },
            transition: "all 0.2s",
            boxShadow: "0 4px 20px rgba(196, 30, 58, 0.3)",
          }}
        >
          Δημιουργησε την Πρωτη σου Λοταρια 🎄
        </Button>
      </Container>
      <Footer />
    </Box>
  );
};
